define('Components/GlossaryWidget/js/views/GlossaryWidgetInstanceView',[
        'jquery',
        'app',
        'underscore',
        'WidgetInstanceView',
        'template!Components/GlossaryWidget/templates/default',
        'template!Components/GlossaryWidget/templates/blocks/ingredients-list',
        'InternalLinkView',
        'backbone',
        'string'
    ],
    function (
        $,
        app,
        _,
        WidgetInstanceView,
        defaultTemplate,
        ingrdientsListTemplate,
        InternalLinkView,
        Backbone
    ) {
        var searchResultsCache = [];
        var ELLIPSIS = '...';
        var MAX_INGREDIENT_DESCRIPTION_CHAR = {
            mobile: 200,
            desktop: 450
        };
        var hash = '';

        return WidgetInstanceView.extend({
            name: 'GlossaryWidgetInstanceView',
            events: {
                'keydown .Glossary-Widget__search__input input': 'handleOnKeyDown',
                'click .Glossary-Widget__ingredient-item__description .show-more': 'showMoreDescription',
                'click .Glossary-Widget__ingredient-item__related .show-more': 'showMoreProducts'
            },
            getTemplate: function () {
                switch (this.model.getTemplate()) {
                    default:
                        return defaultTemplate;
                }
            },
            setup: function () {
                if (window.location.hash) {
                    hash = window.location.hash.substring(1).replace('ingredient-', '');
                }

                this.listenTo(this.model, 'change', this.renderIngredients);
                this.getIngredients('', hash);
            },
            renderIngredients: function () {
                var view = this;
                var ingredientsIds = view.model.get('ingredients').pluck('id_ingredient');

                view.$('.Glossary-Widget__ingredient-item').each(function () {
                    console.log($(this).data('id-ingredient'))
                    if (!_.contains(ingredientsIds, '' + $(this).data('id-ingredient'))) {
                        $(this).hide();
                    } else
                        $(this).show();
                });
            },
            handleOnKeyDown: function (e) {
                var view = this;

                setTimeout(function () {
                    var query = $.trim(e.currentTarget.value.toLowerCase());
                    view.getIngredients(query);
                }, 50);
            },
            getIngredients: function (query, id) {
                var filteredIngredientsCollection = searchResultsCache[query] || this.filterIngredients(query, id);
                this.model.set('ingredients', filteredIngredientsCollection);
            },
            render: function () {
                this.$el.html(this.getTemplate()(this.getTemplateOptions()));
                this.$el = $(this.el);
                this.input = this.$el.find('.Glossary-Widget__search__input input');
                $('.inline-loader').remove();
                this.renderList();
            },
            filterIngredients: function (searchQuery, id) {
                var query = $.trim(searchQuery.toLowerCase());
                var queryTokens = query.split(' ');
                var getIngredientsByQuery = this.model.getIngredients()
                    .where({in_glossary: true})
                    .filter(function (ingredient) {
                        if (!(!!ingredient.get('name'))) return false;
                        var isFound = true;
                        var ingredientTokens = $.trim(ingredient.get('name').toLowerCase()).split(' ');

                        queryTokens.forEach(function (queryToken) {
                            if (!isFound) return;
                            isFound = ingredientTokens.some(function (ingredientToken) {
                                return ingredientToken.startsWith(queryToken);
                            })
                        });

                        return isFound;
                    })
                    .map(function (ingredient) {
                        $.trim(ingredient.get('name').toLowerCase()).startsWith(query)
                        ? ingredient.set('score', 50)
                        : ingredient.set('score', 0);
                        return ingredient;
                    });

                var getIngredientsById = this.model.getIngredients()
                    .where({in_glossary: true, id_ingredient: id});

                var ingredientsCollection = new Backbone.Collection(
                    id ? getIngredientsById : getIngredientsByQuery
                );

                ingredientsCollection.comparator = function (a, b) {
                    return (b.get('score') - a.get('score')) || (a.get('name').localeCompare(b.get('name')));
                };
                ingredientsCollection.sort();

                searchResultsCache[query] = ingredientsCollection; // Memoize result

                return ingredientsCollection;
            },
            renderList: function () {
                var view = this;
                this.$('.Glossary-Widget__ingredients-list').html(ingrdientsListTemplate({ingredients: view.model.get('ingredients')}));
                InternalLinkView.initializeLinksOfView(this);
                var deviceType = app.isMobile() ? 'mobile' : 'desktop';
                
                setTimeout(function () {
                    $('.Glossary-Widget__ingredient-item__description').each(function () {
                        var content = $(this).html();

                        if (content.length > MAX_INGREDIENT_DESCRIPTION_CHAR[deviceType]) {
                            var truncatedText = content.substr(0, MAX_INGREDIENT_DESCRIPTION_CHAR[deviceType]);
                            var hiddenText = content.substr(MAX_INGREDIENT_DESCRIPTION_CHAR[deviceType], content.length - MAX_INGREDIENT_DESCRIPTION_CHAR[deviceType]);

                            var html =
                                truncatedText +
                                '<span class="ellipsis">' +
                                ELLIPSIS +
                                '</span>' +
                                '<span class="hidden-text">' +
                                '<span>' + hiddenText + '</span>' +
                                '<span class="show-more">' + t('Voir plus', 'UI') + '</span>' +
                                '</span>';

                            $(this).html(html);
                        }
                    });
                    $('.Glossary-Widget__ingredient-item').each(function () {
                        var shouldDisplayShowMore = false;
                        $(this).find('.Glossary-Widget__ingredient-item__related__products li').each(function (index) {
                            if (index > 4) {
                                shouldDisplayShowMore = true;
                                $(this).addClass('--hidden');
                            }
                        });
                        if (shouldDisplayShowMore) {
                            $(this).find('.Glossary-Widget__ingredient-item__related').append('<span class="show-more">' + t('Voir plus', 'UI') + '</span>');
                        }
                    })
                }, 500)


            },
            showMoreDescription: function (e) {
                var $currentTarget = $(e.currentTarget);
                if ($currentTarget.hasClass('--less')) {
                    $currentTarget.removeClass('--less');
                    $currentTarget.html(t('Voir plus', 'UI'));
                } else {
                    $currentTarget.addClass('--less');
                    $currentTarget.html(t('Voir moins', 'UI'));
                }
                $currentTarget.parent().prev().toggle();
                $currentTarget.prev().toggle();

            },
            showMoreProducts: function (e) {
                var $currentTarget = $(e.currentTarget);
                if ($currentTarget.hasClass('--less')) {
                    $currentTarget.removeClass('--less');
                    $currentTarget.html(t('Voir plus', 'UI'));
                } else {
                    $currentTarget.addClass('--less');
                    $currentTarget.html(t('Voir moins', 'UI'));
                }
                $currentTarget.prev().find('li:gt(4)').toggleClass('--hidden');
            }
        })
    });
